import generateShortID from "../../../../../../../utils";

export const PADDING_CONFIG = {
  padding_config: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
  },
};

export const MARGIN_CONFIG = {
  margin_config: {
    bottom: 8,
    left: 8,
    right: 8,
    top: 8,
  },
};

export const TEXT_CONFIG = {
  color: "#242424",
  font_family: "sans-serif" /* "sans-serif" || "cursive" || "monospace" */,
  ...MARGIN_CONFIG,
  ...PADDING_CONFIG,
  size: 16 /* min: 12, max: 24 */,
  style: "normal" /* "normal" || "bold" || "italic" */,
  text: "Text",
  localized_messages: {},
};

export const IMAGE_ONLY_REDIRECTION_CONFIG = {
  action: "dismiss",
  activity: "",
  is_deep_link: false,
};

export const BUTTON_CONFIG = {
  action_config: {
    action: "dismiss" /* "dismiss" || "redirect" || "cancel" */,
    activity: "",
    is_deep_link: false,
  },
  borders: {
    radius: 0,
    stroke_color: "#000000",
    stroke_width: 0,
  },
  color: "#27a4f2",
  id: "",
  ...MARGIN_CONFIG,
  ...PADDING_CONFIG,
  text_config: {
    ...TEXT_CONFIG,
  },
  visibility: 1,
};

export const ACTIONS_ENUM = {
  DISMISS: "dismiss",
  REDIRECT: "redirect",
  CANCEL: "cancel",
};

const ANIMATION_CONFIG = {
  duration: 400,
  enabled: true,
  type: "cycle" /* "cycle" || "bounce" */,
};

export const CONSTANT_CONFIGS = {
  language_attribute: "",
  localization_enabled: false,
};

export const POSITION_ENUM = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
  LEFT: "LEFT",
  RIGHT: "RIGHT",
};

export const CONTAINER_CONFIG = {
  bg_color: "#FFFFFF",
  opacity: 1,
  position: POSITION_ENUM.BOTTOM,
  border: {
    color: "#045343",
    width: 0,
  },
  button_position: "right" /* "center" || "left" || "right" */,
  corners: {
    enabled: true,
    width: 8,
  },
  dimmed_background: false,
  dismiss_outside_touch: false,
  layout_type: "default",
  view_id: "",
  animation: {
    ...ANIMATION_CONFIG,
  },
};

export const ACTION_BUTTON_CONFIG = {
  color: "#fff",
  visibility: 1,
  text_config: {
    text: "Title",
    size: 17,
    style: "bold",
    color: "#002845",
    font_family: "sans-serif",
  },
  image:
    "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",
  description_config: {
    text: "Description",
    size: 14,
    style: "normal",
    color: "#A1AFBB",
    font_family: "sans-serif",
  },
  action_config: {
    action: "dismiss",
    activity: "",
    is_deep_link: false,
  },
  __id: generateShortID(),
};
